import { useState } from 'react';
import {
  MaternityChipsItem,
  MaternityChipsSection,
  StickySection,
} from './styled';

export default function MaternityChips(props) {
  const {
    chips,
    activeElement,
    setActiveElement,
    chipsRef,
    showHeader,
    wrapHeight,
  } = props;
  const [focusElement, setFocusElement] = useState('');
  const chipClickHandler = (element) => {
    setFocusElement('lowOpacity');
    if (element === activeElement) {
      setActiveElement((prev) => prev - 100);
      setTimeout(() => {
        setFocusElement('active');
      }, 400);
      return;
    }
    setActiveElement(element);
    setTimeout(() => {
      setFocusElement('');
    }, 400);
  };

  return (
    <StickySection showHeader={showHeader}>
      <MaternityChipsSection wrapHeight={wrapHeight} ref={chipsRef}>
        {chips?.map((element, index) => {
          return (
            <MaternityChipsItem
              id={element?._id}
              chip={element?._id}
              className={`${element?._id === '4091' ? 'active' : ''} ${
                activeElement === element?._id ? focusElement : ''
              }`}
              key={'chip' + index}
              onClick={() => chipClickHandler(element?._id)}
            >
              {element?.heading?.toLowerCase()}
            </MaternityChipsItem>
          );
        })}
      </MaternityChipsSection>
    </StickySection>
  );
}
